var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('q-card',{staticClass:"full-width full-height"},[_c('q-card-actions',{staticClass:"bg-accent text-white q-pa-md"},[_c('div',{staticClass:"title"},[_vm._v("Page Help")]),_c('q-space'),_c('q-btn',{staticClass:"q-mr-sm sustainability-button",staticStyle:{"width":"100px"},attrs:{"loading":_vm.isLoading,"color":"primary"},on:{"click":function($event){return _vm.save(true)}}},[_vm._v(" Save & Close ")]),_c('q-btn',{attrs:{"flat":"","icon":"mdi-close","size":"5","round":""},on:{"click":_vm.closeDialog}})],1),_c('q-card-section',{staticClass:"q-pa-none"},[_c('div',{staticClass:"row q col-gutter-x-lg q-col-gutter-y-md"},[_c('div',{staticClass:"col-12"},[_c('q-card',{attrs:{"flat":""}},[_c('q-card-section',[_c('div',{staticClass:"row q-mb-sm items-center"},[_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"row items-center q-col-gutter-x-md"},[_c('div',{staticClass:"col-3"},[_c('div',{staticClass:"title q-my-none"},[_vm._v("Info")])])])])]),_c('q-form',{ref:"form"},[_c('div',{staticClass:"row q-col-gutter-y-sm q-mb-lg q-col-gutter-x-lg"},[_c('div',{staticClass:"col-12"},[_c('q-input',{attrs:{"label":`Path (The Path is the last part of the URL, For example, the path for this page would be /pageHelp/${_vm.formData.id})`,"rules":[(v) => !!v || 'Field is Required'],"hint":``},model:{value:(_vm.formData.path),callback:function ($$v) {_vm.$set(_vm.formData, "path", $$v)},expression:"formData.path"}})],1),_c('div',{staticClass:"col-12"},[_c('q-editor',{staticStyle:{"height":"300px"},attrs:{"dense":_vm.$q.screen.lt.md,"toolbar":[
                        [
                          {
                            label: _vm.$q.lang.editor.align,
                            icon: _vm.$q.iconSet.editor.align,
                            fixedLabel: true,
                            list: 'only-icons',
                            options: ['left', 'center', 'right', 'justify'],
                          },
                          {
                            label: _vm.$q.lang.editor.align,
                            icon: _vm.$q.iconSet.editor.align,
                            fixedLabel: true,
                            options: ['left', 'center', 'right', 'justify'],
                          },
                        ],
                        [
                          'bold',
                          'italic',
                          'strike',
                          'underline',
                          'subscript',
                          'superscript',
                        ],
                        ['token', 'hr', 'link', 'custom_btn'],
                        ['print', 'fullscreen'],
                        [
                          {
                            label: _vm.$q.lang.editor.formatting,
                            icon: _vm.$q.iconSet.editor.formatting,
                            list: 'no-icons',
                            options: [
                              'p',
                              'h1',
                              'h2',
                              'h3',
                              'h4',
                              'h5',
                              'h6',
                              'code',
                            ],
                          },
                          {
                            label: _vm.$q.lang.editor.fontSize,
                            icon: _vm.$q.iconSet.editor.fontSize,
                            fixedLabel: true,
                            fixedIcon: true,
                            list: 'no-icons',
                            options: [
                              'size-1',
                              'size-2',
                              'size-3',
                              'size-4',
                              'size-5',
                              'size-6',
                              'size-7',
                            ],
                          },
                          {
                            label: _vm.$q.lang.editor.defaultFont,
                            icon: _vm.$q.iconSet.editor.font,
                            fixedIcon: true,
                            list: 'no-icons',
                            options: [
                              'default_font',
                              'arial',
                              'arial_black',
                              'comic_sans',
                              'courier_new',
                              'impact',
                              'lucida_grande',
                              'times_new_roman',
                              'verdana',
                            ],
                          },
                          'removeFormat',
                        ],
                        [
                          'quote',
                          'unordered',
                          'ordered',
                          'outdent',
                          'indent',
                        ],

                        ['undo', 'redo'],
                        ['viewsource'],
                      ],"fonts":{
                        arial: 'Arial',
                        arial_black: 'Arial Black',
                        comic_sans: 'Comic Sans MS',
                        courier_new: 'Courier New',
                        impact: 'Impact',
                        lucida_grande: 'Lucida Grande',
                        times_new_roman: 'Times New Roman',
                        verdana: 'Verdana',
                      }},model:{value:(_vm.formData.text),callback:function ($$v) {_vm.$set(_vm.formData, "text", $$v)},expression:"formData.text"}})],1)])])],1)],1)],1)])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }